import { useState, useEffect } from '@wordpress/element';
import { useSelect, dispatch } from '@wordpress/data';
import { TextControl, PanelBody, PanelRow, ToggleControl, Button, FormTokenField, SelectControl, Dropdown, RangeControl, DateTimePicker, Notice } from '@wordpress/components';
import { sprintf, _n, __} from '@wordpress/i18n';
import DatePicker from 'react-datepicker';

const ExcludedDates = () => {
    const [{ enableExcludedDates,enableTime,stateHours, stateMinutes }, setState] = useState({
        enableExcludedDates: false,
        enableTime:[],
        stateHours:0,
        stateMinutes:0
    })

    const allData = useSelect((select) => {
        return select('WPTravel/TripEdit').getAllStore()
    }, []);

    const { updateTripData, updateRequestSending, setTripData, updateStateChange } = dispatch('WPTravel/TripEdit');
    
    let excludedDatesTimes = 'undefined' !== typeof allData.excluded_dates_times ? allData.excluded_dates_times : [];


    useEffect(()=>{
        let _enableTime = [];
        excludedDatesTimes.map((excludedDateTime,excludedDateTimeIndex)=>{
            let isEnabled = 'undefined' !== typeof excludedDateTime.trip_time && '' !== excludedDateTime.trip_time?true:false
            _enableTime = [..._enableTime,isEnabled ]
        })
        let _enableExcludedDates = excludedDatesTimes.length>0?true:false;
        setState((prevState)=>{
            return {...prevState, enableTime:_enableTime,enableExcludedDates:_enableExcludedDates}
        })

        updateTripData({
            ...allData,
            enable_excluded_dates_times:_enableExcludedDates
        })
        
    },[])

    const updateExcludedDatesTimes = (data, index) => {
        let excludedDatesTimesCollection = allData.excluded_dates_times;
        excludedDatesTimesCollection[index] = { ...excludedDatesTimesCollection[index], ...data }
        updateTripData({
            ...allData,
            excluded_dates_times:[...excludedDatesTimesCollection]
        })
    }

    const addTripExcludedDatesTimes = ()=>{
        let excludedDatesTimesCollection = [...allData.excluded_dates_times,{
            title:"",
            start_date:""
        }];
        updateTripData({
            ...allData,
            excluded_dates_times:[...excludedDatesTimesCollection]
        })
    }
    
    const startParams =  {
		showMonthDropdown: true,
		showYearDropdown: 'select',
		dropdownMode: "select",
		// minDate: new Date(),
		// maxDate: typeof newEndDate != 'undefined' && newEndDate || '',
	}
    return <><div className="wp-travel-ui wp-travel-ui-card wp-travel-ui-card-top-border exclude-date-time-panel">
        <h4>{ __( 'Exclude Dates & time', 'wp-travel' ) }</h4>
        <PanelRow>
            <label>{ __( 'Enable Dates & time exclude', 'wp-travel' ) }</label>
            <ToggleControl
                checked={enableExcludedDates}
                onChange={() => {
                    setState((prevState) => {
                        return { ...prevState, enableExcludedDates: !enableExcludedDates }
                    })

                    updateTripData({
                        ...allData,
                        enable_excluded_dates_times:!enableExcludedDates
                    })
                }}
            />
        </PanelRow>
        {enableExcludedDates&&excludedDatesTimes.length>0&&<><hr/><PanelRow className="wp-travel-action-section"><span></span><Button isDefault onClick={() => addTripExcludedDatesTimes()}>{ __( '+ Add Excluded Date & Time', 'wp-travel' ) }</Button></PanelRow>
        {excludedDatesTimes.map((excludedDateTime,excludedDateTimeIndex)=>{
            let title=  'undefined' !== typeof excludedDateTime.title ?excludedDateTime.title:''
            let selectedTimes = 'undefined' !== typeof excludedDateTime.trip_time && '' !== excludedDateTime.trip_time?excludedDateTime.trip_time.split(','):[];
            selectedTimes = selectedTimes.filter((dateTime)=>{
                return dateTime !='';
            })
            let _start_date = moment( excludedDateTime.start_date )
                            _start_date = _start_date.isValid() ? _start_date.toDate():new Date();
            return <>
            <PanelBody
                initialOpen={false}
                title={title?title:`Excluded Dates ${excludedDateTimeIndex+1}`}
                key={`excluded-dates-times-${excludedDateTimeIndex}`}
            >
                <PanelRow>
                    <label>{ __( 'Label', 'wp-travel' ) }</label>
                    <TextControl value={title} onChange={(label)=>{
                         updateExcludedDatesTimes({title:label},excludedDateTimeIndex);
                    }} />
                </PanelRow>
                <PanelRow>
                <label>Date</label>
                    <DatePicker
                        className='exclude-date-time'
                        selected={ _start_date }
                        { ...startParams }
                        onChange={ ( date ) =>{
                            if( moment(date).isSame(_start_date ) ) {
                                return false;
                            }
                            let _date = moment(date).format('YYYY-MM-DD');
                            updateExcludedDatesTimes({start_date:_date},excludedDateTimeIndex);
                        }}
                    />
        
                </PanelRow>
                {/* <h4>Time</h4> */}
                <PanelRow>
                    <label>{ __( 'Enable Time', 'wp-travel' ) }</label>
                    <ToggleControl
                    checked={enableTime[excludedDateTimeIndex]}
                    onChange={ () => {
                        let _enableTime =  enableTime;
                        _enableTime[excludedDateTimeIndex] = !enableTime[excludedDateTimeIndex];
                        setState((prevState)=>{
                            return {...prevState, enableTime:_enableTime}
                        })

                        updateExcludedDatesTimes({trip_time:''},excludedDateTimeIndex);
                    } }
                />
                </PanelRow>

                { 'undefined' !== typeof enableTime[excludedDateTimeIndex] && enableTime[excludedDateTimeIndex]&&<><PanelRow>
                        <label>{ __( 'Select Time', 'wp-travel' ) }</label>
                        <div className="text-right">
                            <FormTokenField 
                                label=""
                                value={ selectedTimes } 
                                suggestions={ [] } 
                                onChange={ tokens =>{
                                    let _tokens = tokens.filter((token)=>{
                                        return token.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm);
                                    })
                                    updateExcludedDatesTimes({trip_time:_tokens.join(',')},excludedDateTimeIndex);
                                }}
                                placeholder={ __( 'Select Time', 'wp-travel' ) }
                            />

                            <Dropdown
                                className="my-container-class-name"
                                contentClassName="my-popover-content-classname"
                                position="bottom right"
                                renderToggle={ ( { isOpen, onToggle } ) => (
                                    <Button onClick={ onToggle } aria-expanded={ isOpen } isLink>{ __( '+ Add Time', 'wp-travel' ) }</Button>
                                ) }
                                renderContent={ ({ isOpen, onToggle } ) => (
                                    <div className="wp-travel-dropdown-content-wrap">
                                    <div>
                                            <label>{ __( 'Hours', 'wp-travel' ) }</label>
                                            <RangeControl
                                                // label="Hours"
                                                value={ stateHours }
                                                onChange={ ( hours ) => {
                                                    // hours = hours < 10 ? '0'+hours:hours;
                                                    setState( (prevState)=>{
                                                        return { ...prevState, stateHours:hours }
                                                    } )
                                                }}
                                                min={ 0 }
                                                max={ 23 }
                                            />
                                    </div>
                                    <div>
                                            <label>{ __( 'Minute', 'wp-travel' ) }</label>
                                            <RangeControl
                                                // label="Hours"
                                                value={ stateMinutes }
                                                onChange={ ( minutes ) => {
                                                    // hours = hours < 10 ? '0'+hours:hours;
                                                    setState( (prevState)=>{
                                                        return { ...prevState, stateMinutes:minutes }
                                                    } )
                                                }}
                                                min={ 0 }
                                                max={ 59 }
                                            />
                                    </div>
                                    <div className="wp-travel-add-time">
                                        <Button onClick={()=>{
                                            let _minutes = stateMinutes < 10 ? '0'+stateMinutes:stateMinutes;
                                            let _hours = stateHours < 10 ? '0'+stateHours:stateHours;
                                            let time = `${_hours}:${_minutes}`;
                                            if ( time.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm) && !selectedTimes.includes(time) ){
                                                let newSelectedTimes = [...selectedTimes,time];
                                                newSelectedTimes.sort((ls,rs)=>{
                                                    if( ls < rs ) return -1;
                                                    if( ls > rs ) return 1;
                                                    return 0;
                                                })

                                                updateExcludedDatesTimes({trip_time:newSelectedTimes.join(',')},excludedDateTimeIndex);
                                            }
                                            onToggle()
                                        }} isDefault>{ __( '+ Add', 'wp-travel' ) }</Button>

                                    </div>
                                    </div>
                                ) }
                            />
                        </div>
                        
                    </PanelRow>
                </>}
                 <hr/>                       
                <PanelRow>
                    <span></span>
                    <Button isDefault onClick={() => {
                        if (!confirm( __( 'Are you sure to delete this date?', 'wp-travel' ) )) {
                            return false;
                        }
                        
                        let _excludedDatesTimes = [];
                        _excludedDatesTimes = excludedDatesTimes.filter((_excludedDateTime,_excludedDateTimeIndex) => {
                            return _excludedDateTimeIndex != excludedDateTimeIndex;
                        });

                        updateTripData({
                            ...allData,
                            excluded_dates_times:[..._excludedDatesTimes]
                        })
                    }} className="wp-traval-button-danger">{ __( '- Remove Date & Time', 'wp-travel' ) }</Button>
                </PanelRow>
            </PanelBody>
            </>
        })}
        {enableExcludedDates&&excludedDatesTimes.length>1 && <PanelRow className="wp-travel-action-section"><span></span><Button isDefault onClick={() => addTripExcludedDatesTimes()}>{ __( '+ Add Excluded Date & Time', 'wp-travel' ) }</Button></PanelRow>}
        </>}
        {enableExcludedDates && excludedDatesTimes.length<1 && <>
            
            <Notice isDismissible={false} actions={[{
                'label': __( ' Add excluded dates & time', 'wp-travel' ),
                onClick: () => {
                    addTripExcludedDatesTimes()
                },
                noDefaultClasses: true,
                className: 'is-link'
            }]}>{ __( 'No dates & time excluded.', 'wp-travel' ) }</Notice>
        </>}
    </div>
    </>;
}

export default ExcludedDates;